import { useMemo } from 'react';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { Link } from 'foundations-components/transitional/components/Link';
import { usePaymentFormContext } from '../../context/PaymentFormContext';
import AcknowledgementCheckbox from './AcknowledgementCheckbox';
import ZeroCheckoutTermsOfService from './ZeroCheckoutTermsOfService';
import { useTermsOfServiceDisplay } from '../../hooks/useTermsOfServiceDisplay';
import MaybeFutureChargesTotals from '../FutureCharges/MaybeFutureChargesTotals';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getMessage = ({
  translationMessageKey,
  termsOfServiceUrl,
  companyName,
  isZeroCheckout
}) => {
  if (isZeroCheckout) {
    return /*#__PURE__*/_jsx(ZeroCheckoutTermsOfService, {});
  } else if (!translationMessageKey) {
    return null;
  } else if (termsOfServiceUrl) {
    if (companyName) {
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: translationMessageKey,
        options: {
          href: termsOfServiceUrl,
          companyName
        },
        elements: {
          Link
        }
      });
    } else {
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: translationMessageKey,
        options: {
          href: termsOfServiceUrl
        },
        elements: {
          Link
        }
      });
    }
  } else if (companyName) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: translationMessageKey,
      options: {
        companyName
      }
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: translationMessageKey
  });
};
const TermsOfService = ({
  translationMessageKey,
  isZeroCheckout
}) => {
  var _checkoutSession$user, _checkoutSession$poli;
  const {
    checkoutSession: checkoutSessionMap
  } = usePaymentFormContext();
  const checkoutSession = checkoutSessionMap.toJS();
  const companyName = ((_checkoutSession$user = checkoutSession.userDefinedBranding) === null || _checkoutSession$user === void 0 ? void 0 : _checkoutSession$user.companyName) || null;
  const termsOfServiceUrl = ((_checkoutSession$poli = checkoutSession.policySettingsData) === null || _checkoutSession$poli === void 0 ? void 0 : _checkoutSession$poli.termsOfServiceUrl) || '';
  const {
    shouldShowTermsOfServiceAcknowledgementCheckbox
  } = useTermsOfServiceDisplay();
  const message = useMemo(() => getMessage({
    translationMessageKey,
    termsOfServiceUrl,
    companyName,
    isZeroCheckout
  }), [translationMessageKey, termsOfServiceUrl, companyName, isZeroCheckout]);
  if (!message) {
    return null;
  }
  return /*#__PURE__*/_jsx(View, {
    paddingBlockStart: "300",
    children: shouldShowTermsOfServiceAcknowledgementCheckbox ? /*#__PURE__*/_jsx(AcknowledgementCheckbox, {
      children: message
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [message, " ", /*#__PURE__*/_jsx(MaybeFutureChargesTotals, {
        shouldApplyStyling: false
      })]
    })
  });
};
export default TermsOfService;